import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { ConfirmModal } from "../customs/modals/confirm-modal";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AbTenant } from "app/abstract/full-pages/admin/tenant.abstract";
import { AbNotificacaoFuncionalidade } from "app/abstract/full-pages/grupo-pessoa/notificacao-funcionalidade.abstract";
import { Subject, takeUntil } from "rxjs";
import { DesignSystemSigmaService } from "app/services/design-system-sigma.service";

@Injectable({ providedIn: 'root' })
export class NotificacaoFuncionalidadeService extends AbNotificacaoFuncionalidade implements OnDestroy {
    private readonly destroy$ = new Subject()
    constructor(
        httpClient: HttpClient,
        private modal: NgbModal,
        private router: Router,
        private tenantService: AbTenant,
        private dssService: DesignSystemSigmaService,
        private translate: TranslateService
    ) {
        super(httpClient);
    }

    public exibirConfirmacao(funcionalidade: any): void {
        let modalRef = this.modal.open(ConfirmModal);
        modalRef.componentInstance.description = this.translate.instant('Esta funcionalidade ainda não está habilitada. Deseja notificar o administrador para habilitá-la?');

        modalRef.result.then(() => {
            this.enviarNotificacao(funcionalidade);
            this.goHome();
        }).catch(() => {
            this.goHome();
        });
    }

    public exibirDialog(): void {
        let modalRef = this.modal.open(ConfirmModal);
        modalRef.componentInstance.title = this.translate.instant('Funcionalidade');
        modalRef.componentInstance.description = this.translate.instant('Esta funcionalidade ainda nao esta habilitada. Para habilitar você deve ir em Configurações → Integrações.');
        modalRef.componentInstance.isButtonOk = true;
        modalRef.result.then(() => {
            this.goHome();
        }).catch(() => {
            this.goHome();
        });
    }

    public enviarNotificacao(funcionalidade: any) {
        return this.get(`notificacoes/${funcionalidade}`).pipe(takeUntil(this.destroy$)).subscribe();
    }

    public goHome() {
        if(this.isDssLayout())
            this.router.navigate(['pages/error/dss'], { state: { previousUrl: this.router.url } });
        else
            this.router.navigate(['/home']);
    }

    public verificarModulo(): void {
        let tenant = this.tenantService.getTenantStorage();
        if (!tenant.controleAcesso)
            this.exibirConfirmacao("Controle de acesso");
    }

    isDssLayout(): boolean {
        return this.dssService.isDssLayout();
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

}
